import {WalkthroughDefinition} from '../types';

export const WORKFORCE_DASHBOARD_TOUR_TARGETS = {
  title: 'workforceDashboard.title',
  kpiStrip: 'workforceDashboard.kpiStrip',
  alignmentDistribution: 'workforceDashboard.alignmentDistribution',
  alignmentShape: 'workforceDashboard.alignmentShape',
  departmentHealth: 'workforceDashboard.departmentHealth',
  recurringSkillGaps: 'workforceDashboard.recurringSkillGaps',
  dimensionImbalances: 'workforceDashboard.dimensionImbalances',
  redeploymentCandidates: 'workforceDashboard.redeploymentCandidates',
  profilesRequiringAction: 'workforceDashboard.profilesRequiringAction',
  roleCoverageHeatmap: 'workforceDashboard.roleCoverageHeatmap',
} as const;

export const companyWorkforceDashboardWalkthrough: WalkthroughDefinition = {
  id: 'companyWorkforceDashboard',
  version: 5,
  steps: [
    {
      target: WORKFORCE_DASHBOARD_TOUR_TARGETS.title,
      titleKey: 'walkthrough.workforceDashboard.welcome.title',
      bodyKey: 'walkthrough.workforceDashboard.welcome.body',
      placement: 'bottom-start',
    },
    {
      target: WORKFORCE_DASHBOARD_TOUR_TARGETS.kpiStrip,
      titleKey: 'walkthrough.workforceDashboard.kpiStrip.title',
      bodyKey: 'walkthrough.workforceDashboard.kpiStrip.body',
      placement: 'bottom',
    },
    {
      target: WORKFORCE_DASHBOARD_TOUR_TARGETS.alignmentDistribution,
      titleKey: 'walkthrough.workforceDashboard.alignmentDistribution.title',
      bodyKey: 'walkthrough.workforceDashboard.alignmentDistribution.body',
      placement: 'bottom',
    },
    {
      target: WORKFORCE_DASHBOARD_TOUR_TARGETS.departmentHealth,
      titleKey: 'walkthrough.workforceDashboard.departmentHealth.title',
      bodyKey: 'walkthrough.workforceDashboard.departmentHealth.body',
      placement: 'bottom',
    },
    {
      target: WORKFORCE_DASHBOARD_TOUR_TARGETS.recurringSkillGaps,
      titleKey: 'walkthrough.workforceDashboard.recurringSkillGaps.title',
      bodyKey: 'walkthrough.workforceDashboard.recurringSkillGaps.body',
      placement: 'bottom',
    },
    {
      target: WORKFORCE_DASHBOARD_TOUR_TARGETS.dimensionImbalances,
      titleKey: 'walkthrough.workforceDashboard.dimensionImbalances.title',
      bodyKey: 'walkthrough.workforceDashboard.dimensionImbalances.body',
      placement: 'bottom',
    },
    {
      target: WORKFORCE_DASHBOARD_TOUR_TARGETS.roleCoverageHeatmap,
      titleKey: 'walkthrough.workforceDashboard.roleCoverageHeatmap.title',
      bodyKey: 'walkthrough.workforceDashboard.roleCoverageHeatmap.body',
      placement: 'top',
    },
    {
      target: WORKFORCE_DASHBOARD_TOUR_TARGETS.redeploymentCandidates,
      titleKey: 'walkthrough.workforceDashboard.redeploymentCandidates.title',
      bodyKey: 'walkthrough.workforceDashboard.redeploymentCandidates.body',
      placement: 'top',
    },
    {
      target: WORKFORCE_DASHBOARD_TOUR_TARGETS.profilesRequiringAction,
      titleKey: 'walkthrough.workforceDashboard.profilesRequiringAction.title',
      bodyKey: 'walkthrough.workforceDashboard.profilesRequiringAction.body',
      placement: 'top',
    },
  ],
};
